export default __webpack_public_path__ + "static/media/grace.5bf6e4a1.jpeg";